<template>
  <div class="pdf-wrapper">
    <iframe
      ref="iframeElement"
      :title="title"
      :src="iframeSrc"
      :style="{ width: '100%', height: '100%', background: '#ababab' }"
      frameborder="0"
      scrolling="auto"
    />
  </div>
</template>
<script lang="ts" setup>
import type { MediaSchema } from '~/types/schema';

const breakpoints = useEvaBreakpoints();

const isAboveL = breakpoints.greaterOrEqual('l');

interface Props {
  offsetTop: number;
  pdfObject: MediaSchema;
  title: string;
}

const props = defineProps({
  offsetTop: null,
  pdfObject: null,
  title: null
});

const iframeElement = ref(null);

// const { disciplineId } = inject(INJECT_CATEGORY_PAGE);

// const { category, post } = inject(INJECT_MODAL_CATEGORY);

const pdfHeight = ref<number>(0);

const mobile = computed(() => (isAboveL.value ? 0 : 1));

const handleActivity = () => {
  window.dispatchEvent(new Event('mousemove')); // fake mousemove for idle activity
};

useEventListener(window, 'message', (evt) => {
  if (evt.data.height) pdfHeight.value = evt.data.height;
});

const iframeSrc = computed(
  () =>
    `/pdf/viewer?url=${props.pdfObject.url}&mobile=${mobile.value}&offset-top=${props.offsetTop}`
);

const { height: windowHeight } = useWindowSize();

const cssheight = computed(() => {
  const height =
    toValue(windowHeight) > pdfHeight.value
      ? toValue(windowHeight)
      : pdfHeight.value;
  return `${height}px`;
});

// useAppEventPost(category, disciplineId, post);

onMounted(() => {
  // saveRecommendationOpenedAt($db, 'post', post.value.id);
  iframeElement.value.contentWindow.addEventListener(
    'scroll',
    handleActivity,
    false
  );
  iframeElement.value.contentWindow.addEventListener(
    'mousemove',
    handleActivity,
    false
  );
});
onBeforeUnmount(() => {
  iframeElement.value.contentWindow.removeEventListener(
    'scroll',
    handleActivity
  );
  iframeElement.value.contentWindow.removeEventListener(
    'mousemove',
    handleActivity
  );
});
</script>
<style lang="scss" scoped>
.pdf-wrapper {
  z-index: 1;
  height: 100%;
  min-height: v-bind(cssheight);
  background: #ababab; // pdf viewer background color
  @include above('l') {
    position: relative;
    height: 100%;
    min-height: auto;
    overflow: hidden;
  }
}
.pdf-wrapper-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.pdf {
  position: relative;
  :deep(iframe) {
    position: inherit !important;
  }
}
iframe {
  border: 0;
  outline: 0;
}
</style>
